import { render, staticRenderFns } from "./Envelopes.vue?vue&type=template&id=2a98ce90"
import script from "./Envelopes.vue?vue&type=script&lang=js"
export * from "./Envelopes.vue?vue&type=script&lang=js"
import style0 from "./Envelopes.vue?vue&type=style&index=0&id=2a98ce90&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports